import { render, staticRenderFns } from "./SectionWithForms.vue?vue&type=template&id=3bf5d229&scoped=true&"
import script from "./SectionWithForms.vue?vue&type=script&lang=js&"
export * from "./SectionWithForms.vue?vue&type=script&lang=js&"
import style0 from "./SectionWithForms.vue?vue&type=style&index=0&id=3bf5d229&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf5d229",
  null
  
)

export default component.exports